type VerificarPermissoesParams = {
    permissoesUsuario: string[];
    permissoesRequiridas: string[];
    bancaIdFromComponent?: string | null;
    verificarQualquerPermissao?: boolean;
};

export class PermissaoWrapperHelper {
    // Função exportada para verificar permissões
    public static verificarPermissoes({
        permissoesUsuario,
        permissoesRequiridas,
        bancaIdFromComponent = null,
        verificarQualquerPermissao = false,
    }: VerificarPermissoesParams): boolean {
        // Gera as permissões com o bancaId, se houver
        const permissoesComBancaId = bancaIdFromComponent
            ? permissoesRequiridas.map((p) => `${p}-${bancaIdFromComponent}`)
            : [];

        // Função para verificar permissões com ou sem bancaId
        const verificarPermissao = (permissao: string): boolean => {
            if (bancaIdFromComponent) {
                // Se bancaId estiver presente, verifica apenas com bancaId
                return permissoesComBancaId.some((p) => permissoesUsuario.includes(p));
            } else {
                // Caso contrário, verifica tanto com quanto sem bancaId
                return permissoesUsuario.some(
                    (pUsuario) => pUsuario === permissao || permissoesUsuario.some((p) => p.startsWith(`${permissao}-`))
                );
            }
        };

        // Verifica as permissões com base na estratégia (qualquer ou todas)
        if (verificarQualquerPermissao) {
            // Verifica se o usuário tem pelo menos uma das permissões requeridas
            return permissoesRequiridas.some((p) => verificarPermissao(p));
        } else {
            // Verifica se o usuário tem todas as permissões requeridas
            return permissoesRequiridas.every((p) => verificarPermissao(p));
        }
    }
}
